const initialState = {
  totalInventoryValue: null,
  loading: false,
};

export const totalInventoryValueReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_TOTAL_INVENTORY_VALUE":
      return {
        ...state,
        totalInventoryValue: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const alertsInitialState = {
  inventoryAlerts: null,
  loading: false,
};

export const inventoryAlertsReducer = (state = alertsInitialState, action) => {
  switch (action.type) {
    case "GET_INVENTORY_ALERTS":
      return {
        ...state,
        inventoryAlerts: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const compositionInitialState = {
  inventoryComposition: null,
  loading: false,
};

export const inventoryCompositionReducer = (state = compositionInitialState, action) => {
  switch (action.type) {
    case "GET_INVENTORY_COMPOSITION":
      return {
        ...state,
        inventoryComposition: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const topSectionsInitialState = {
  inventoryTopSections: null,
  loading: false,
};

export const inventoryTopSectionsReducer = (state = topSectionsInitialState, action) => {
  switch (action.type) {
    case "GET_INVENTORY_TOP_SECTIONS":
      return {
        ...state,
        inventoryTopSections: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const rePurchasesInitialState = {
  inventoryRePurchases: null,
  loading: false,
};

export const inventoryRePurchasesReducer = (state = rePurchasesInitialState, action) => {
  switch (action.type) {
    case "GET_INVENTORY_RE_PURCHASES":
      return {
        ...state,
        inventoryRePurchases: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const affiliateInitialState = {
  affiliateLeaderboard: null,
  loading: false,
};

export const affiliateLeaderboardReducer = (state = affiliateInitialState, action) => {
  switch (action.type) {
    case "GET_AFFILIATE_LEADERBOARD":
      return {
        ...state,
        affiliateLeaderboard: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const dealProgressInitialState = {
  inventoryDealProgress: null,
  loading: false,
};

export const inventoryDealProgressReducer = (state = dealProgressInitialState, action) => {
  switch (action.type) {
    case "GET_INVENTORY_DEAL_PROGRESS":
      return {
        ...state,
        inventoryDealProgress: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};
